import {apiAuthFetcher, apiFetcher} from "~/lib/fetchers";
import type {operations} from "~/types/api-types";

export type OpeningHourResponse = operations["getOpeningHours"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"]

export async function getOpeningHour(request: { active?: boolean }): Promise<OpeningHourResponse> {
  return apiFetcher<OpeningHourResponse>("/public/branch/opening-hours", {
    method: "GET",
    params: { ...request },
  });
}

export type OpeningHourPatchRequest = operations["changeOpeningHours"]["requestBody"]["content"]["application/json"]
export async function putOpeningHour(request: OpeningHourPatchRequest) {
  return apiAuthFetcher("/admin/branch/opening-hours", {
    method: "PUT",
    body: {
      ...request
    }
  })
}

export type OpeningHourActiveRequest = operations["setOpeningHoursActive"]["requestBody"]["content"]["application/json"]
export async function putOpeningHourActive(request: OpeningHourActiveRequest) {
  return apiAuthFetcher("/admin/branch/opening-hours/active", {
    method: "PUT",
    body: {
      ...request
    }
  })
}
